(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["try-on-button"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('#spreeai-try-on');

  if (container && !container.dataset.initialized) {
    container.dataset.initialized = 'true';

    const garmentId = container.dataset.garmentId;
    const metaOutfit = container.dataset.outfit;
    const sizesRaw = container.dataset.sizes;

    let garments = [{ garmentId }];
    let sizes = [];

    if (metaOutfit) {
      const outfit = JSON.parse(metaOutfit);
      garments = outfit.garments;
    }

    if (sizesRaw) {
      try {
        sizes = JSON.parse(sizesRaw);
      } catch (error) {
        console.error('Failed to parse SpreeAI sizes JSON', error);
      }
    }

    import('https://unpkg.com/@spreeai/web-sdk@2.1.0/dist/@spreeai/web-sdk.js')
      .then(async ({ init }) => {
        const spreeAI = await init({
          clientId: '3ee7f9f9-9d01-0000-0100-5c9a83f521fa',
        });

        if (!spreeAI) {
          return;
        }

        spreeAI.renderTryOnButton({
          garments: garments.map((g, index) => {
            if (index === 0) {
              return {
                garmentId: g.garmentId,
                availableSizes: sizes,
              };
            }
            return g;
          }),
          defaultUnits: 'metric',
          elementId: 'spreeai-try-on',
          features: {
            tryOnButton: {
              text: garments.length > 1 ? 'Try This Look' : 'Try it on',
            },
          },
        });
      })
      .catch((error) => {
        console.error('Failed to load SpreeAI SDK', error);
      });
  }
  } catch(e) { console.error(e); }
})();

})();
